export default __webpack_public_path__ + "img/icon_revisions.png";